import React from 'react';
// import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import CustomerList from './CustomerList'

function BulkReassign(props) {

  return(
    <div id="wrapper">
      <div className="content-area">
        <Sidebar history={props.history} />
        <CustomerList/>
        {/* <div className="container"></div> */}
      </div>
    </div>
  )
}
export default BulkReassign;